import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import BooksMenu from '../BooksMenu';
import css from './BooksSelectedStaff.module.scss';
import { RSButton } from 'src/reservation-page/RSButton';

interface Props {
  className?: string;
  changeStaff: () => void;
  id: string | number;
  name: string;
  withBorderBottom?: boolean;
  withBorderTop?: boolean;
  withPaddingLarge?: boolean;
}

const BooksSelectedStaff = ({
  className,

  name,
  changeStaff,
  withBorderBottom,
  withBorderTop,
  withPaddingLarge,
}: Props) => {
  const intl = useIntl();
  const classes = classNames(
    css.BooksSelectedStaff,
    {
      [css.withBorderTop]: withBorderTop,
      [css.withBorderBottom]: withBorderBottom,
      [css.withPaddingLarge]: withPaddingLarge,
    },
    className,
  );

  return (
    <div className={classes}>
      <BooksMenu menuName={name} />
      <div className="ml-8">
        <RSButton variant="outline" onClick={changeStaff}>
          {intl.formatMessage({ id: 'books.button.change' })}
        </RSButton>
      </div>
    </div>
  );
};

export default BooksSelectedStaff;
